module.exports = __webpack_public_path__ + "img/mentos_avatar.35ad86d0.jpeg";